import { useRef } from 'react';
import { getSocket } from '../socket';

const THROTTLE_MS = 1500;

export function useEditingBroadcast() {
    const lastSentAt = useRef(0);
    return () => {
        const now = Date.now();
        if (now - lastSentAt.current < THROTTLE_MS) return;
        lastSentAt.current = now;
        getSocket().emit('trip:editing');
    };
}
